import config from "config.js";
import * as Sentry from "@sentry/browser";
import { getUserIdFromStorage } from 'lib/hooks'
import axiosServices from "v2/utils/axios";

export const boot = () => () => {
	const initializeServices = (email: string, firstname: string, surname: string, id: string) => {
		const name = `${firstname} ${surname}`;

		/**
		 * Sentry
		 */
		Sentry.init({ dsn: config.Sentry.dsn, release: config.version });
		Sentry.configureScope(scope => scope.setUser({ name, username: email, email, id }));

		/**
		 * Google Analytics
		 */
		//@ts-ignore
		if (window.ga) {
			//@ts-ignore
			window.ga("create", config.GoogleAnalytics.accessToken, "auto");
		}

		/**
		 * Intercom
		 */
		//@ts-ignore
		if (window.Intercom) {
			//@ts-ignore
			window.Intercom("boot", { app_id: config.Intercom.app_id });
			//@ts-ignore
			window.Intercom("update", { name, email, id, user_id: id, update_last_request_at: true });
		}

		/**
		 * Zendesk
		 */
		//@ts-ignore
		if (window.zE && window.zE.identify) {
			//@ts-ignore
			window.zE(() => window.zE.identify({ name, email }));
		}
	};

	if (localStorage.getItem('user')) {
		const user = JSON.parse(localStorage.getItem('user') || '{}');
		initializeServices(user.email, user.firstname, user.surname, user.id);
	} else {
		axiosServices.get(`${process.env.REACT_APP_API_ENDPOINT_V2}users/${getUserIdFromStorage()}`).then(session => {
			const { email, firstname, surname, id } = session.data.user;
			initializeServices(email, firstname, surname, id);
		}).catch(error => {
			console.error(error);
		});
	}
};
